import React from 'react';
import { RFCStyles, sharedStyles } from 'Views/Pages/Pdf/styles';
import { Text, View } from '@react-pdf/renderer';
import { capitalize } from 'lodash';
import useUnitSelected from 'Hooks/useUnitSelected';
import { RequirementNode } from 'Views/Pages/Frontend/StudyPlanWizard/RequirementTreeGeneration';
import { CourseEntity, StudyPlanEntity } from 'Models/Entities';
import { DataIndex } from 'Util/DataIndexUtils';
import {
	DuplicateCourseItem,
} from 'Views/Pages/Frontend/StudyPlanWizard/RequirementFulfilmentCheck/DuplicateCourseSelection';

interface StructureUnitSelectedProps {
	requirementTree: Record<string, RequirementNode>,
	studyPlan: StudyPlanEntity,
	coursesById: DataIndex<CourseEntity>,
	duplicateCourses: DuplicateCourseItem[],
}

const StructureUnitSelected = (props: StructureUnitSelectedProps) => {
	const {
		requirementTree,
		studyPlan,
		coursesById,
		duplicateCourses,
	} = props;

	const {
		displayingRequirements,
		totalUnitsSelected,
		duplicateUnitsSelected,
		requiredTotalUnitCondition,
	} = useUnitSelected({
		requirementTree: requirementTree,
		studyPlan: studyPlan,
		coursesById,
		duplicateCourses,
	});

	const getUnitLabel = ({ unitCount, unitMinimum }: RequirementNode) => {
		const unitTotalSuffix = unitMinimum === undefined
			? ''
			: `/${unitMinimum}`;

		return `${unitCount}${unitTotalSuffix}`;
	};

	return (
		<View style={RFCStyles.programStructureAndUnitCountWrapper}>
			<View style={RFCStyles.programStructureAndUnitCount}>
				<Text
					style={[sharedStyles.darkGrey, { marginBottom: 12 }]}
				>
					{capitalize(window.lexicon.program)} {window.lexicon.structure}
				</Text>
				<Text style={{ fontWeight: 'bold', marginBottom: 8 }}>
					{studyPlan?.programStructure.getDisplayName()}
				</Text>
				<Text>{studyPlan?.programStructure.description}</Text>
			</View>
			<View style={RFCStyles.programStructureAndUnitCount}>
				<Text style={[sharedStyles.darkGrey, { marginBottom: 12 }]}>
					{capitalize(window.lexicon.units)} selected
				</Text>
				{displayingRequirements.map(({ requirementNode, requirement }) => {
					return (
						<View
							key={requirement.id}
							style={[RFCStyles.unitSelectItem, { marginBottom: 8 }]}
						>
							<Text>{requirement.displayName}</Text>
							<Text>{getUnitLabel(requirementNode)}</Text>
						</View>
					);
				})}
				<View style={{ borderTop: '1px solid #E3E3E3' }} />
				<View style={[RFCStyles.unitSelectItem, { fontWeight: 'bold', marginTop: 8 }]}>
					<Text>{capitalize(window.lexicon.program)} Total</Text>
					<Text>
						{totalUnitsSelected}
						{
							requiredTotalUnitCondition !== undefined
								? `/${requiredTotalUnitCondition?.units}`
								: null
						}
					</Text>
				</View>
				<View style={[RFCStyles.unitSelectItem, { marginTop: 8 }]}>
					<Text>{capitalize(window.lexicon.duplicates)}</Text>
					<Text>{duplicateUnitsSelected}</Text>
				</View>
			</View>
		</View>
	);
};

export default StructureUnitSelected;
